<template>
  <div class="highscore">
    <Nav />
    <div class="nav-spacer" />
    <b-container class="highscore-container">
      <div class="custom-headline headline" v-text="$ml.get('Greeting')"></div>
      <div class="quick-info" v-text="$ml.get('text')"></div>
      <b-button-group class="select-button-group">
        <button
          class="btn"
          :class="{ active: allTime }"
          @click="allTime = true"
        >
          Alltime
        </button>
        <button
          class="btn"
          :class="{ active: !allTime }"
          @click="checkFirstClick"
        >
          Letzter Tag
        </button>
      </b-button-group>
    </b-container>
    <b-container class="score-panel-container desktop">
      <ScorePanel
        v-if="allTime"
        :headline="$ml.get('punkte')"
        :scores="allTimePoints"
        class="panel"
      />
      <ScorePanel
        v-else
        :headline="$ml.get('punkte24')"
        :scores="dailyPoints"
        class="panel"
      />
      <TimePanel
        v-if="allTime"
        :headline="$ml.get('zeiten')"
        :scores="allTimeTimes"
        class="panel"
      />
      <TimePanel
        v-else
        :headline="$ml.get('zeiten24')"
        :scores="dailyTimes"
        class="panel"
      />
    </b-container>
    <b-container class="score-panel-container desktop">
      <ScorePanel
        v-if="allTime"
        :headline="$ml.get('distanz')"
        :scores="allTimDistance"
        class="panel"
      />
      <ScorePanel
        v-else
        :headline="$ml.get('distanz24')"
        :scores="dailyDistance"
        class="panel"
      />
    </b-container>
    <b-container class="score-panel-container mobile">
      <b-tabs align="center" justified>
        <b-tab>
          <template slot="title">
            <span v-if="allTime" v-text="$ml.get('punkte')"></span>
            <span v-else v-text="$ml.get('punkte24')"></span>
          </template>
          <ScorePanel v-if="allTime" :scores="allTimePoints" class="panel" />
          <ScorePanel v-else :scores="dailyPoints" class="panel" />
        </b-tab>
        <b-tab>
          <template slot="title">
            <span v-if="allTime" v-text="$ml.get('zeiten')"></span>
            <span v-else v-text="$ml.get('zeiten24')"></span>
          </template>
          <ScorePanel v-if="allTime" :scores="allTimDistance" class="panel" />
          <ScorePanel v-else :scores="dailyDistance" class="panel" />
        </b-tab>
        <b-tab>
          <template slot="title">
            <span v-if="allTime" v-text="$ml.get('distanz')"></span>
            <span v-else v-text="$ml.get('distanz24')"></span>
          </template>
          <ScorePanel v-if="allTime" :scores="allTimDistance" class="panel" />
          <ScorePanel v-else :scores="dailyDistance" class="panel" />
        </b-tab>
      </b-tabs>
    </b-container>
    <hr />
    <div class="footer-center">
      <Footer />
    </div>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ScorePanel from "../components/ScorePanel";
import TimePanel from "../components/TimePanel";
// import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { MLBuilder } from "vue-multilanguage";

export default {
  name: "Highscores",
  components: { Nav, Footer, ScorePanel, TimePanel },
  data() {
    return {
      allTime: true,
      allTimePoints: [],
      dailyPoints: [],
      allTimeTimes: [],
      dailyTimes: [],
      allTimDistance: [],
      dailyDistance: [],
      dailyClicked: false,
    };
  },
  computed: {
    ...mapGetters("authentication", ["name"]),
    mlGreeting() {
      return new MLBuilder("greeting").with("name", this.name);
    },
  },
  mounted() {
    this.getPoints(true);
    this.getTimes(true);
    this.getDistance(true);
  },
  methods: {
    mapArrays(topXArray, userDataArray, previousArray, followingArray) {
      let returnArray = [];
      // check position
      let position = null;
      let maxTopXArrayLength = topXArray.length;
      if (maxTopXArrayLength > 12) maxTopXArrayLength = 12;

      if (previousArray.length > 0) {
        if (maxTopXArrayLength > 5) maxTopXArrayLength = 5;
        if (followingArray.length < 3) {
          let toAdd = 4 - followingArray.length;
          for (let i = 1; i < toAdd; i++) {
            if (typeof topXArray[maxTopXArrayLength + i] !== "undefined")
              maxTopXArrayLength++;
            else break;
          }
        }
      } else {
        position = topXArray.findIndex(
          (x) =>
            x.user_name === (userDataArray[0] ? userDataArray[0].user_name : "")
        );
      }
      // push top x
      for (let i = 0; i < maxTopXArrayLength; i++) {
        if (position !== null && position === i) {
          pushArray(topXArray, i, true);
        } else {
          pushArray(topXArray, i);
        }
      }
      // check if we need more
      if (maxTopXArrayLength < 9 && topXArray.length > 0) {
        returnArray[maxTopXArrayLength - 1].fade = true;
        // push previous entries
        for (let i = 0; i < previousArray.length; i++) {
          pushArray(previousArray, i);
        }
        // push user entry
        for (let i = 0; i < userDataArray.length; i++) {
          pushArray(userDataArray, i, true);
        }
        // push entries after
        for (let i = 0; i < followingArray.length; i++) {
          pushArray(followingArray, i);
        }
      }
      // return array
      return returnArray;

      // helper function
      function pushArray(array, index, user = false) {
        returnArray.push({
          score: array[index].score
            ? array[index].score
            : array[index].distance
            ? array[index].distance
            : 0,
          difficulty: array[index].difficulty
            ? array[index].difficulty
            : "leicht",
          user_name: array[index].user_name,
          position: array[index].position,
          user: user,
          fade: false,
        });
      }
    },
    mapArraysForTimes(topXArray, userDataArray, previousArray, followingArray) {
      let returnArray = [];
      // check position
      let position = null;
      let maxTopXArrayLength = topXArray.length;
      if (maxTopXArrayLength > 12) maxTopXArrayLength = 12;

      if (previousArray.length > 0) {
        if (maxTopXArrayLength > 5) maxTopXArrayLength = 5;
        if (followingArray.length < 3) {
          let toAdd = 4 - followingArray.length;
          for (let i = 1; i < toAdd; i++) {
            if (typeof topXArray[maxTopXArrayLength + i] !== "undefined")
              maxTopXArrayLength++;
            else break;
          }
        }
      } else {
        position = topXArray.findIndex(
          (x) =>
            x.user_name === (userDataArray[0] ? userDataArray[0].user_name : "")
        );
      }
      // push top x
      for (let i = 0; i < maxTopXArrayLength; i++) {
        if (position !== null && position === i) {
          pushArray(topXArray, i, true);
        } else {
          pushArray(topXArray, i);
        }
      }
      // check if we need more
      if (maxTopXArrayLength < 9 && topXArray.length > 0) {
        returnArray[maxTopXArrayLength - 1].fade = true;
        // push previous entries
        for (let i = 0; i < previousArray.length; i++) {
          pushArray(previousArray, i);
        }
        // push user entry
        for (let i = 0; i < userDataArray.length; i++) {
          pushArray(userDataArray, i, true);
        }
        // push entries after
        for (let i = 0; i < followingArray.length; i++) {
          pushArray(followingArray, i);
        }
      }
      // return array
      return returnArray;

      // helper function
      function pushArray(array, index, user = false) {
        returnArray.push({
          time: array[index].time,
          user_name: array[index].user_name,
          position: array[index].position,
          user: user,
          fade: false,
        });
      }
    },
    async getPoints(allTime = false) {
      // choose the url
      let url = "";
      if (allTime) {
        url = "/api/getTopAlltimeScores";
      } else {
        url = "/api/getTopTodayScores";
      }
      const response = await this.axios.get(url, {
        params: {
          slide_name: "proslide",
          n: 12,
        },
      });
      // console.log("points", response.data);

      let values = null;
      if (response.data.data.list !== null) {
        values = this.extractResponse(response.data.data.list);
      } else {
        values = [];
      }

      if (allTime) {
        this.allTimePoints = values;
      } else {
        this.dailyPoints = values;
      }
    },
    async getTimes(allTime = false) {
      // choose the url
      let url = "";
      if (allTime) {
        url = "/api/getTopAlltimeTimes";
      } else {
        url = "/api/getTopTodayTimes";
      }
      const response = await this.axios.get(url, {
        params: {
          slide_name: "proslide",
          n: 12,
        },
      });
      console.log("times", response.data);
      let values = null;
      if (response.data.data.list !== null) {
        values = this.extractResponse(response.data.data.list, true);
      } else {
        values = [];
      }
      console.log(values);

      if (allTime) {
        this.allTimeTimes = values;
      } else {
        this.dailyTimes = values;
      }
    },
    async getDistance(allTime = false) {
      let prd = "";
      if (allTime) {
        prd = "all";
      } else {
        prd = "today";
      }

      const response = await this.axios.get("/api/getTopNSlideDistances", {
        params: {
          slide_name: "proslide",
          allTime: allTime,
          prd: prd,
          n: 12,
        },
      });
      // console.log("distance", response.data);

      let values = null;
      if (response.data.data.list !== null) {
        values = this.extractResponse(response.data.data.list);
      } else {
        values = [];
      }

      if (allTime) {
        this.allTimDistance = values;
      } else {
        this.dailyDistance = values;
      }
    },
    extractResponse(resData, isTimes = false) {
      let topXArray = [];
      let userArray = [];
      let previousArray = [];
      let followingArray = [];
      if (typeof resData !== "undefined") {
        if (typeof resData.topXList !== "undefined")
          topXArray = resData.topXList;
        if (typeof resData.surroundingList !== "undefined") {
          if (typeof resData.surroundingList.userData !== "undefined")
            userArray = resData.surroundingList.userData;
          if (typeof resData.surroundingList.previous !== "undefined")
            previousArray = resData.surroundingList.previous;
          if (typeof resData.surroundingList.following !== "undefined")
            followingArray = resData.surroundingList.following;
        }
      }

      if (isTimes)
        return this.mapArraysForTimes(
          topXArray,
          userArray,
          previousArray,
          followingArray
        );
      else
        return this.mapArrays(
          topXArray,
          userArray,
          previousArray,
          followingArray
        );
    },
    checkFirstClick() {
      if (!this.dailyClicked) {
        this.dailyClicked = true;
        this.getPoints();
        this.getDistance();
        this.getTimes();
      }
      this.allTime = false;
    },
  },
};
</script>

<style scoped>
.score-panel-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 15px;
}

.panel {
  min-width: 290px;
  margin: 10px;
}

.select-button-group {
  width: 320px;
}

.select-button-group .btn {
  width: 50%;
  color: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(0, 167, 255, 0.5);
  font-weight: bold;
}

.select-button-group .btn:hover,
.select-button-group .btn:focus {
  background-color: rgba(0, 167, 255, 1);
  outline: none;
  box-shadow: none;
}

.btn.active {
  background-color: rgba(0, 167, 255, 1);
  color: white;
}

.score-panel-container.desktop {
}

.score-panel-container.mobile {
  display: none;
}

@media (max-width: 576px) {
  .score-panel-container.desktop {
    display: none;
  }
  .score-panel-container.mobile {
    display: flex;
  }
}
</style>
